import React from "react";
import Banner from "./component/Banner";
import Category from "./component/Category";
import Order from "./orders"
import Subcategory from "./component/Subcategory";
import NewArrival from "./component/Newarrival";
import Sale from "./component/Sale";

const Home = () => {
  return (
    <div className="w-full">
      <Banner />

      <div className="w-full max-w-[85rem] mx-auto mt-[50px]">
        <Category />
        <NewArrival />
        <Subcategory />
        <Sale />

        <div className="flex mt-10">Home</div>
        
      </div>
      <Order />
    </div>
  );
};

export default Home;
